import { render, staticRenderFns } from "./flexibee.vue?vue&type=template&id=591f6154&"
import script from "./flexibee.vue?vue&type=script&lang=js&"
export * from "./flexibee.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports